import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      Configuration: 'Configuration',
      Config: 'Config',
      NavigationFiltersNoFilterDataMessage: 'No filter data found',
      GeneralErrorMessage: 'Ups something went wrong.',
      ContactAdministratorMessage: 'Please try again or contact your application manager.',
      ErrorMessage: 'Page not found. Please reach out to your administrator',
      ThemeCustomizationPageTitle: 'OS Screen Background',
      ThemeCustomizationSelectClient: 'Select Client',
      ThemeCustomizationSectionAddLogos: 'Add Logos',
      ThemeCustomizationSectionAddImages: 'Add Images',
      ThemeCustomizationHeaderLogo: 'Header Logo',
      ThemeCustomizationHeaderImage: 'Header Image',
      ThemeCustomizationFooterLogo: 'Footer Logo',
      ThemeCustomizationFooterImage: 'Footer Image',
      Save: 'Save',
      FileDeleteConfirmation: 'Are you sure you want to delete this file?',
      FileDeleteApproval: 'Yes, delete file',
      DiscardChangesConfirmation: 'Are you sure you want to discard all your changes?',
      DiscardChangesApproval: 'Yes, discard changes',
      Apply: 'Apply',
      Cancel: 'Cancel',
      Ok: 'Ok',
      Quit: 'Quit',
      Delete: 'Delete',
      SuccessfulDeleteMessage: 'Deleted',
      QuitConfirmation: 'If you leave the page now your unsaved input will be lost. Proceed?',
      DropzoneButtonUploadFiles: 'Upload Files',
      ThemeCustomizationValidationMessage:
        'Select client and upload a file at least in one section',
      AddData: 'Add Data',
      CreatedOn: 'Created On',
      CreatedBy: 'Created By',
      UpdatedOn: 'Updated On',
      UpdatedBy: 'Updated By',
      TableSearchErrorMessage: `Sorry, we were not able to find a match with your search.
        <br /> Please <b>check your spelling</b> or <b>try another search.</b>`,
      ClientProfileSuccessMessage: 'Client profile created successfully',
      ClientProfileDeleteSuccessMessage: 'Client profile deleted successfully!',
      ClientProfileErrorMessage: 'Unable to create client profile',
      ClientProfileUpdateErrorMessage: 'Unable to update client profile',
      ClientProfilesLoadErrorMessage: 'Could not load client profiles',
      ClientProfileDeleteConfirmation: 'Are you sure you want to delete that client profile?',
      ClientProfileDeleteError: 'Could not delete profile successfully',
      NotFound: 'Not Found',
      NoPermission: 'No permission to view data.',
      ErrorMessageForIncorrectURL:
        'You do not have permission to view this data context. Please check your url parameters. If you need access please get in touch with the support team.',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b'],
    useSuspense: true,
  },
});

export default i18n;
